import styled from 'styled-components';

import { styledMedia, styledTypography } from '@pkg/primitives';

import { tokens } from './CurrencyChip.tokens';

export const StyledCurrencyChip = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    gap: ${tokens.padding}px;
    padding-left: ${tokens.padding}px;
    padding-right: ${tokens.padding * 2}px;
    height: ${tokens.height}px;
    border-radius: 999px;
    border: 1px solid rgb(255, 255, 255, 0.1);
`;

export const Symbol = styled.div`
    display: grid;
    place-items: center;
    place-content: center;
    width: ${tokens.symbolSize}px;
    height: ${tokens.symbolSize}px;
    border-radius: 999px;
    background-color: rgb(255, 255, 255, 0.1);
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.iconSize}px;
    height: ${tokens.iconSize}px;
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.labelSize}px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;
